import {
  ROUTE_MODULE_ACTIVATION,
  ROUTE_MODULE_OPTIMIZE_AND_REPORTING,
} from '../../../utils/routes';
import { ModuleLinkSection } from './ModuleLinkSection';
import { t } from '../../../utils/resources';

interface MakeItWorkSectionProps {
  onClick: (item?: string) => void;
}

export const MakeItWorkSection = ({ onClick }: MakeItWorkSectionProps) => (
  <div className="submenu" onMouseLeave={() => onClick('')}>
    <ul>
      <ModuleLinkSection
        module={ROUTE_MODULE_ACTIVATION}
        permission={'Webframe.Header.MakeItWork.Activate'}
        title={t('Menu.Activate')}
        description={t('Menu.Activate.Description')}
        onClick={onClick}
      />
      <ModuleLinkSection
        module={ROUTE_MODULE_OPTIMIZE_AND_REPORTING}
        permission={'Webframe.Header.MakeItWork.OptimizeAndReport'}
        title={t('Menu.Reporting')}
        description={t('Menu.Reporting.Description')}
        onClick={onClick}
      />
    </ul>
  </div>
);
